import * as TYPES from './mutationTypes'

export default {
  //服务配置list
  [TYPES.GET_ORACLE_LIST](state, payload) {
    const { limit, offset } = payload.result
    const total = payload.result.total
    Object.assign(state, {
      oracle_list: payload.result.items,
      oracle_paging: { limit, offset, total }
    })
  }
}
